import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArrowNavigationDirective } from 'src/app/directive/arrow-navigation.directive';
import { SheetPercentagePipe } from './pipe/sheet-percentage.pipe';

@NgModule({
  declarations: [ArrowNavigationDirective, SheetPercentagePipe],
  imports: [CommonModule],
  exports: [ArrowNavigationDirective, SheetPercentagePipe],
})
export class SharedModule {}
